<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OFLQHl/tc-custom/9780226555959.jpg?1731179950682" alt="This image is the cover for the book Amber Waves"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amber Waves
      </h1>
      <p class="bookDescription body article font2">
        <b>A biography of a staple grain we often take for granted, exploring how wheat went from wild grass to a world-shaping crop.</b><br/><br/> At breakfast tables and bakeries, we take for granted a grain that has made human civilization possible, a cereal whose humble origins belie its world-shaping power: wheat. <i>Amber Waves</i> tells the story of a group of grass species that first grew in scattered stands in the foothills of the Middle East until our ancestors discovered their value as a source of food. Over thousands of years, we moved their seeds to all but the polar regions of Earth, slowly cultivating what we now know as wheat, and in the process creating a world of cuisines that uses wheat seeds as a staple food. Wheat spread across the globe, but as ecologist Catherine Zabinski shows us, a biography of wheat is not only the story of how plants ensure their own success: from the earliest bread to the most mouthwatering pasta, it is also a story of human ingenuity in producing enough food for ourselves and our communities.<br/><br/> Since the first harvest of the ancient grain, we have perfected our farming systems to grow massive quantities of food, producing one of our species’ global mega crops—but at a great cost to ecological systems. And despite our vast capacity to grow food, we face problems with undernourishment both close to home and around the world. Weaving together history, evolution, and ecology, Zabinski’s tale explores much more than the wild roots and rise of a now-ubiquitous grain: it illuminates our complex relationship with our crops, both how we have transformed the plant species we use as food, and how our society—our culture—has changed in response to the need to secure food sources. From the origins of agriculture to gluten sensitivities, from our first selection of the largest seeds from wheat’s wild progenitors to the sequencing of the wheat genome and genetic engineering, <i>Amber Waves</i> sheds new light on how we grow the food that sustains so much human life.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Catherine Zabinski
      </h2>
      
      <p class="authorDescription body article"><B>Catherine Zabinski</B> is professor of plant and soil ecology in the Department of Land Resources and Environmental Sciences at Montana State University in Bozeman. She received a fellowship from the Arthur P. Sloan Foundation to work on this book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?744242f8